import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { CreateOfferPage } from '../../features/offers/create/create-offer-page';
import { OfferViewForbiddenState } from '../../features/offers/offer-view-forbidden-state';
import { useHasPermission } from '../../hooks/use-has-permission';
import { PageTitleContext } from '../__root';

// Carries the caller's selected media units, calendar term, and any
// already-entered quick-add "creating"-mode data through the "Otwórz pełny
// formularz" navigation so CreateOfferPage can restore them instead of
// starting from a blank form (CU-86cb1nqwv, extended by CU-86cb8grgn).
export const OffersNewSearchSchema = z.object({
  mediaUnitIds: z.array(z.coerce.number().int().positive()).optional(),
  clientId: z.coerce.number().int().positive().optional(),
  salespersonId: z.coerce.number().int().positive().optional(),
  defaultDateFrom: z.coerce.date().optional(),
  defaultDateTo: z.coerce.date().optional(),
});

export const Route = createFileRoute('/offers/new')({
  validateSearch: OffersNewSearchSchema,
  component: NewOfferRoute,
});

export function NewOfferRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('offers');
  const canViewAll = useHasPermission('offer.view_all', { loading: 'closed' });
  const canCreate = useHasPermission('offer.prepare', { loading: 'closed' });
  const canCreateClient = useHasPermission('client.create', { loading: 'closed' });
  const canView = canViewAll || canCreate;

  React.useEffect(() => {
    setPageTitle(t('create.pageTitle'));
  }, [setPageTitle, t]);

  if (!canView) {
    return <OfferViewForbiddenState />;
  }

  return <CreateOfferPage canCreate={canCreate} canCreateClient={canCreateClient} />;
}
